import React from 'react'
import Helmet from 'react-helmet'
import { getCurrentLangKey, getLangs, getUrlForLang } from 'ptz-i18n';
import { IntlProvider } from 'react-intl';
import 'intl';
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import './all.sass'
import { StaticQuery, graphql } from "gatsby"

import { Location } from '@reach/router'

import logo from '../img/logoBoA.svg'

import { addLocaleData } from 'react-intl';

import messages_fr from '../data/messages/fr';
import fr from 'react-intl/locale-data/fr';
import 'intl/locale-data/jsonp/fr';

import messages_en from '../data/messages/en';
import en from 'react-intl/locale-data/en';
import 'intl/locale-data/jsonp/en';

addLocaleData(fr);
addLocaleData(en);

const i18nMessages = {
    'fr': messages_fr,
    'en': messages_en
};

function getLangKey(location, data) {
    const url = location.pathname;
    const { langs, defaultLangKey } = data.site.siteMetadata.languages;
    const langKey = getCurrentLangKey(langs, defaultLangKey, url);

    return langKey;
}

function getLangsMenu(location, data) {
    const url = location.pathname;
    const { langs, defaultLangKey } = data.site.siteMetadata.languages;
    const langKey = getCurrentLangKey(langs, defaultLangKey, url);
    const homeLink = `/${langKey}/`;
    const langsMenu = getLangs(langs, langKey, getUrlForLang(homeLink, url));

    return langsMenu;
}

const TemplateWrapper = ({ children, data }) => {
    //console.log('location');
    //console.log(location);

    /*
    const url = window.location.pathname;
    const { langs, defaultLangKey } = data.site.siteMetadata.languages;
    const langKey = getCurrentLangKey(langs, defaultLangKey, url);
    const homeLink = `/${langKey}/`;
    const langsMenu = getLangs(langs, langKey, getUrlForLang(homeLink, url));
    */

    return (
        <Location>
            {({ location }) => {
                return (
                    <IntlProvider
                        locale={getLangKey(location, data)}
                        messages={i18nMessages[getLangKey(location, data)]}
                    >
                        <div>
                            <Helmet>
                                <title>{i18nMessages[getLangKey(location, data)].title}</title>
                                <link rel="shortcut icon" type="image/svg" href="{logo}" />
                                <meta name="google-site-verification" content="p5Hh3F-AlKnNlcwyg-c73FHT3uy3ECSh4fv1JNEpK8U" />
                            </Helmet>
                            <Navbar langs={getLangsMenu(location, data)} locale={getLangKey(location, data)}/>
                            <div className="navbar-margin">{children}</div>
                            <Footer locale={getLangKey(location, data)} />
                        </div>
                    </IntlProvider>
                )
            }}
        </Location>
    )
}

export default props => (
    <StaticQuery
        query={graphql`
            query {
                site {
                    siteMetadata {
                        languages {
                            defaultLangKey
                            langs
                        }
                    }
                }
            }
        `}
        render={data => <TemplateWrapper data={data} {...props} />}
    />
)
